import { render, staticRenderFns } from "./WelcomeStep.vue?vue&type=template&id=64f3417e&scoped=true"
import script from "./WelcomeStep.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeStep.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WelcomeStep.vue?vue&type=style&index=0&id=64f3417e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f3417e",
  null
  
)

export default component.exports